module.exports = __webpack_public_path__ + "img/esteeDW1.f43efda1.jpg";